import { getFormattedSlug } from '@src/pages/[...slug]/components/collection/utils'
import { getQuinceStorefrontUrl } from '@src/utils/b2b/b2b.utils'

import { ContentfulExperimentConfig } from '../ContentfulExperimentConfig'

import ContentfulImage, { ContentfulImageForMenuItem } from './ContentfulImage'

// @i18n-ignore-start
export const PLATFORM_TYPES = {
  ALL: 'ALL',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  APP: 'APP',
}
// @i18n-ignore-end

type ValuesOf<T> = T[keyof T]

export type PlatformTypes = ValuesOf<typeof PLATFORM_TYPES>
export interface IContentfulLink {
  id: string
  text: string
  subText?: ContentfulSubText | null
  entry?: ContentfulEntry | null
  logo?: ContentfulImage | ContentfulImageForMenuItem
  url?: string | null
  scrollToHash?: string | null
  slug?: string | null
  textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]
  applicablePlatforms?: PlatformTypes[] | null
  openInNewTab?: boolean | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  ctaType?: string | null
}

interface ContentfulSubText {
  raw: string
}
interface ContentfulEntry {
  name?: string | null
  slug: string
}

export default class ContentfulLink implements IContentfulLink {
  readonly id: string
  readonly text: string
  readonly logo?: ContentfulImage | ContentfulImageForMenuItem
  readonly subText?: ContentfulSubText | null
  readonly entry?: ContentfulEntry | null
  readonly url?: string | null
  readonly slug?: string | null
  readonly scrollToHash?: string | null
  readonly textColor?: string | null
  experimentConfig?: ContentfulExperimentConfig[]
  applicablePlatforms?: PlatformTypes[] | null
  openInNewTab?: boolean | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  ctaType?: string | null
  constructor({
    text,
    subText,
    entry,
    url,
    slug,
    id,
    logo,
    textColor,
    experimentConfig,
    applicablePlatforms,
    openInNewTab,
    liveShowId,
    preserveQueryParams,
    ctaType,
  }: IContentfulLink) {
    this.id = id
    this.text = text
    this.subText = subText
    this.entry = entry
    this.url = url
    this.slug = slug
    this.scrollToHash = slug
    this.textColor = textColor
    this.logo = logo
    this.experimentConfig = experimentConfig
    this.applicablePlatforms = applicablePlatforms
    this.openInNewTab = openInNewTab
    this.liveShowId = liveShowId
    this.preserveQueryParams = preserveQueryParams
    this.ctaType = ctaType
    return {
      ...this,
    }
  }

  static getLinkPath = (link: ContentfulLink | null | undefined, isB2BFooter?: boolean) => {
    let linkPath = '/'

    if (!link) linkPath = '/'
    else if (link?.entry?.slug) linkPath = `/${getFormattedSlug(link.entry.slug)}`
    else if (link?.slug) linkPath = `/${getFormattedSlug(link.slug)}`
    else if (link?.url) linkPath = link.url

    if (isB2BFooter) linkPath = getQuinceStorefrontUrl(linkPath)

    return linkPath
  }
}
